import { MetricsBarProps } from './index';
import { todayStr, weekStart, monthStart, fmtHrs } from '@/lib/time';

export type UseHooksParams = MetricsBarProps;

export const useHooks = ({ dayMap }: UseHooksParams) => {
  const today = todayStr();
  const currentWeekStart = weekStart(today);
  const currentMonthStart = monthStart(today);
  
  // 1. Today
  const todayHours = dayMap[today] || 0;
  const todayVal = fmtHrs(todayHours);
  const todaySub = todayHours > 0 ? "logged today" : "no entries today";
  
  // 2. This Week (Monday to today/Sunday)
  let weekHours = 0;
  for (const [dateStr, hrs] of Object.entries(dayMap)) {
    if (weekStart(dateStr) === currentWeekStart) {
      weekHours += hrs;
    }
  }
  const weekVal = fmtHrs(weekHours);
  const weekSub = `Week of ${currentWeekStart}`;
  
  // 3. This Month (1st of current month to end of month)
  let monthHours = 0;
  for (const [dateStr, hrs] of Object.entries(dayMap)) {
    if (monthStart(dateStr) === currentMonthStart) {
      monthHours += hrs;
    }
  }
  const monthVal = fmtHrs(monthHours);
  const monthSub = today.substring(0, 7); // e.g. YYYY-MM
  
  // 4. Total
  let totalHours = 0;
  for (const hrs of Object.values(dayMap)) {
    totalHours += hrs;
  }
  const totalVal = fmtHrs(totalHours);
  const uniqueDaysCount = Object.keys(dayMap).length;
  const totalSub = `${uniqueDaysCount} day${uniqueDaysCount !== 1 ? 's' : ''} logged`;
  
  return {
    todayVal,
    todaySub,
    todayHours,
    weekVal,
    weekSub,
    monthVal,
    monthSub,
    totalVal,
    totalSub
  };
};
